<template>
    <div @click="ddfk_open = false; ddfk_dist_open = false;">


        <section id="signup">


            <div class="columns mt0 mb0 pb0">

                <div class="column fullcol is-5 is-hidden-touch">
                    <div class="loginbg">

                        <p class="loginbg-txt">
                            O FACILIMO É A PLATAFORMA QUE <br>
                            AJUDA A REALIZAR PROJECTOS
                        </p>


                        <div class="loginbgsocial">
                            <p>
                                SIGA-NOS
                            </p>
                            <p>
                               <i class="fa fa-facebook-square"></i>
                               <i class="fa fa-instagram"></i>
                               <i class="fa fa-linkedin-square"></i>
                            </p>

                        </div>


                    </div>

                </div>

                <div class="column fullcol is-7-desktop" id="rightcol" style="background-color: #f1f1f1; display:flex;">

                        <div class="formcontainer" style="height:100%;">

                            <div class="loginaction">

                                <div class="loginlogo" @click="$router.push({path:'/'})" style="cursor:pointer;">
                                    <img src="/static/images/layout/logotop.png" alt="FACILIMO">
                                </div>

                                <div id="signupflow">

                                    <transition name="fade">

                                        <div v-if="signupFlow == 1" id="flow-step-1">

                                            <p id="registese">REGISTE-SE GRATUITAMENTE</p>

                                            <div class="step1container">
                                                <form>

                                                    <div class="columns">
                                                        <div class="column toggleblock">
                                                            <div class="field has-addons" style="width:100%">
<!--
                                                                <p class="control" style="width:50%">
-->
                                                                <p class="control" style="width:100%">
                                                                    <a class="button" style="width:100%"  :class="[professional ? 'active' : null]" @click="professional=1">
                                                                                                  <span class="icon is-small">
                                                                                                    <i class="fa fa-check"></i>
                                                                                                  </span>
                                                                        <span>SOU PROFISSIONAL</span>
                                                                    </a>
                                                                </p>
                                                                <!--<p class="control" style="width:50%">
                                                                    <a class="button" style="width:100%" :class="[!professional ? 'active' : null]" @click="professional=0">
                                                                                                  <span class="icon is-small">
                                                                                                    <i class="fa fa-check"></i>
                                                                                                  </span>
                                                                        <span>PARTICULAR</span>
                                                                    </a>
                                                                </p>-->
                                                            </div>

                                                        </div>
                                                    </div>


                                                    <transition name="fade">
                                                        <div class="columns" v-if="professional">
                                                            <div class="column">
                                                                <input :class="{'badinput': errors.has('name')}" class="formfield" type="text" name="name" data-vv-as="nome" v-model="name" v-validate="'required|min:3'" placeholder="Designação comercial ou nome*">
                                                            </div>
                                                        </div>
                                                        <div class="columns" v-if="!professional">
                                                            <div class="column">
                                                                <input :class="{'badinput': errors.has('name')}" class="formfield" type="text" name="name" data-vv-as="nome" v-model="name" v-validate="'required|min:3'" placeholder="Nome completo*">
                                                            </div>
                                                        </div>
                                                    </transition>

                                                    <div class="columns">
<!--
                                                        <div class="column is-three-fifths control has-icons-right">
-->
                                                        <div class="column is-three-fifths">
                                                            <input :class="{'badinput': errors.has('email')}" class="formfield" type="text" name="email" data-vv-as="e-mail" data-vv-delay="1000" v-model="email" v-validate="'required|email|uniqueemail'" placeholder="E-mail*">
                                                            <!--<span v-if="errors.has('email')" class="icon is-right has-text-primary">
                                                              <i class="fa fa-exclamation-triangle" style="font-size: 1.25rem;margin-top: -0.25rem;"></i>
                                                            </span>-->
                                                        </div>
                                                        <div class="column is-two-fifths" style="position: relative;">
                                                            <span>
                                                                <img src="/static/images/signup/pt.svg"
                                                                     style="width: 1rem;
                                                                       position: absolute;
                                                                       top: 1.1rem;
                                                                       left: 0.9rem;"/>
                                                            </span>
                                                            <input style="padding-left:2rem;" :class="{'badinput': errors.has('phone')}" class="formfield" data-vv-delay="1000" type="text" name="phone" data-vv-as="telemóvel" v-model="phone" v-validate="'required|min:11|uniquephone'" placeholder="Telemóvel*" v-mask="'### ### ###'">
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column">
                                                            <input :class="{'badinput': errors.has('address')}" class="formfield" type="text" name="address" data-vv-as="morada" v-model="address" v-validate="'required|min:5'" placeholder="Morada*">
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column is-half">
                                                            <input :class="{'badinput': errors.has('zip_home')}" class="formfield" type="text" name="zip_home" data-vv-as="código postal" v-model="zip_home" v-validate="'required|min:8'" placeholder="Código postal*" v-mask="'####-###'">
                                                        </div>
                                                        <div class="column is-half">
                                                            <input :class="{'badinput': errors.has('city')}" class="formfield" type="text" name="city" data-vv-as="localidade" v-model="city" v-validate="'required|min:2'" placeholder="Localidade*" >
                                                        </div>
                                                    </div>


                                                </form>
                                                <div style="margin-top:0.5rem;padding-top:0.5rem;text-align:left;color:rgb(132, 138, 150); min-height:5rem;">
                                                    <p style="font-size: 0.7rem;"><em>* Campos obrigatórios.</em></p>
                                                    <div style="min-heigth:2.5rem;">
                                                        <div v-if="errors.collect('email').length > 0">
                                                            <p v-if="errors.collect('email')[0] == 'O e-mail encontra-se já registado.'" class="has-text-primary" style="font-size: 0.7rem;"><em>{{ errors.collect('email')[0] }}</em></p>
                                                        </div>
                                                        <div v-if="errors.collect('phone').length > 0">
                                                            <p v-if="errors.collect('phone')[0] == 'O telemóvel encontra-se já registado.'" class="has-text-primary" style="font-size: 0.7rem;"><em>{{ errors.collect('phone')[0] }}</em></p>
                                                        </div>

<!--
                                                        <a href="" class="button" @click="test">test</a>
-->
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                        <div class="stepcontent" v-if="signupFlow == 2" id="flow-step-2" >

                                            <p id="step2title">
                                                Ganhe novos clientes!
                                            </p>
                                            <p id="step2text">
                                                Indique-nos os serviços que realiza. Iremos enviar-lhe
                                                novos pedidos de clientes gratuitamente.
                                                Decida quais os clientes a contactar e envie uma proposta.
                                            </p>
                                            <p style=" color: #2d3256;
        font-weight: 500;
        text-align: left;
        padding: 1rem 0 1rem;
        font-size:1rem;">
                                                Que serviços realiza?
                                            </p>
                                            <div id="fakeddbutton" class="field has-addons" style="position: relative;width: 100%;cursor:pointer;">

                                                <div class="fakeddcontainer">
                                                    <p class="fakedd" :class="{'badinput': lv1error}" @click.stop="ddfk_open = true;"> {{lv1opt[lv1]}}
                                                        <i class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#2d3256"></i>
                                                    </p>

                                                    <input id="type" type="text"  :value="lv1opt[lv1]" name="lv1" style="display: none;">
                                                    <div v-if="ddfk_open" class="ddfake-open">
                                                        <p v-for="t, index in lv1opt" v-if="index > 0" class="ddfake-opt" @click="lv1 = index; ddfk_open = false;">{{lv1opt[index]}}</p>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="columns is-mobile" style="width:100%">

                                                <div class="column is-half">
                                                    <a :class="{'stepinfo': step2info == 1}" class="button f-button is-info is-fullwidth f-signup-btn" @click="step2info = 1" >
                                                        <span>Como funciona o Facilimo?</span>
                                                        <span class="icon">
                                                          <i class="fa fa-caret-right"></i>
                                                        </span>
                                                    </a>
                                                    <a :class="{'stepinfo': step2info == 2}" class="button f-button is-info is-fullwidth f-signup-btn" @click="step2info = 2">
                                                        <span>É necessário pagar?</span>
                                                        <span class="icon">
                                                          <i class="fa fa-caret-right"></i>
                                                        </span>
                                                    </a>
                                                    <a :class="{'stepinfo': step2info == 3}" class="button f-button is-info is-fullwidth f-signup-btn" @click="step2info = 3">
                                                        <span>Como funcionam os pedidos?</span>
                                                        <span class="icon">
                                                          <i class="fa fa-caret-right"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <div class="column is-half">
                                                    <div :style="'opacity:'+step2info" class="step2open">
                                                        <i class="fa fa-times" style="position: absolute; top:0.2rem;right:0.2rem;cursor:pointer" @click="step2info = 0"></i>

                                                        {{step2text[step2info]}}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="stepcontent" v-if="signupFlow == 3" id="flow-step-3" >

                                            <p class="steptitle">
                                                Que tipos de serviços realiza?
                                            </p>
                                            <p class="steptext">
                                                Pode sempre alterar estas categorias.
                                            </p>


                                            <div :class="{'badinput': lv2error}" class="step-list" v-if="lv1>0">
                                                <p class="step-list-item" v-for="sg in subgroups" v-if="sg.main_group_id == lv1" @click="toggleItem(sg.id, lv2)">
                                                    <span>
                                                        <transition name="fade" mode="out-in">
                                                            <i v-if="isItemActive(sg.id,lv2)" class="fa fa-fw fa-check-square" style="color:#e90054;"></i>
                                                            <i v-else class="fa fa-fw fa-square-o" style="color:#e90054;"></i>
                                                        </transition>
                                                    </span>
                                                    {{sg.title}}
                                                </p>


                                            </div>

                                        </div>

                                        <div class="stepcontent" v-if="signupFlow == 4" id="flow-step-4" >

                                            <p class="steptitle">
                                                Que tipos de serviços realiza?
                                            </p>
                                            <p class="steptext">
                                                Pode sempre alterar estas categorias.
                                            </p>


                                            <div :class="{'badinput': lv3error}" class="step-list" v-if="lv1>0">
                                                <p class="step-list-item" v-for="s in groups[lv1-1]" v-if="isItemActive(s.sub_group_id,lv2)" @click="toggleItem(s.id, lv3)">
                                                    <span>
                                                        <transition name="fade" mode="out-in">
                                                            <i v-if="isItemActive(s.id,lv3)" class="fa fa-fw fa-check-square" style="color:#e90054;"></i>
                                                            <i v-else class="fa fa-fw fa-square-o" style="color:#e90054;"></i>
                                                        </transition>
                                                    </span>
                                                    {{s.title}}
                                                </p>


                                            </div>



                                        </div>

                                        <div class="stepcontent" v-if="signupFlow == 5" id="flow-step-5" >

                                            <p class="steptitle">
                                                De que forma trabalha com seus clientes?
                                            </p>
                                            <p class="steptext">
                                                É importante definir a sua área de trabalho.
                                            </p>

                                            <div class="f-signup-geo">
                                                <div class="columns mb0">
                                                    <div class="column is-half">
                                                        <p>Qual o seu código postal?</p>
                                                        <div>
                                                            <input :class="{'badinput': ziperror}" class="formfield" v-mask="'####-###'" @keyup="zip_work.length > 7 ? treatZip() : null;" @blur="geoCode" type="text" name="zip_work" data-vv-as="código postal" v-model="zip_work" v-validate="'required'" placeholder="Código postal">
                                                        </div>
	                                                    <p :class="zip_response.class" style="font-size: 0.8rem"><em>{{zip_response.message}}</em></p>

                                                    </div>

                                                    <div class="column is-half">
                                                        <p id="lbl-distance" style="white-space: nowrap">Até onde se pode deslocar?</p>
                                                        <div id="fakeddbutton-dist" class="field has-addons" style="position: relative;width: 100%;cursor:pointer;">

                                                            <div class="fakeddcontainer" style="margin-top:0.2rem;">
                                                                <p style="padding:0.2rem 0.5rem;" class="fakedd" @click.stop="ddfk_dist_open = true;"> {{distance}} km
                                                                    <i class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#2d3256"></i>
                                                                </p>
                                                                <div v-if="ddfk_dist_open" class="ddfake-open" >
                                                                    <p v-for="t, index in distopt" class="ddfake-opt" @click="distance = distopt[index]; ddfk_dist_open = false;">{{distopt[index]}} km</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div id="map" class="mb20" v-if="!zip_response.error">
                                                    <gmap-map ref="map" class="signup-map-container" :language="'pt-PT'" :center="center" :zoom="zoom" :options="{
                                                    language: 'pt-PT',
                                                    disableDefaultUI: true
                                                    }">
                                                        <gmap-circle :center="center" :radius="radius" :options="{
                                                            strokeColor: '#e90054',
                                                            strokeOpacity: 0.8,
                                                            strokeWeight: 2,
                                                            fillColor: '#e90054',
                                                            fillOpacity: 0.35,
                                                            }">
                                                        </gmap-circle>
                                                    </gmap-map>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="stepcontent" v-if="signupFlow == 6" id="flow-step-6" >


                                            <p class="steptitle">
                                                Como pretende ser contactado?
                                            </p>
                                            <p class="steptext">
                                                Indique ou confirme seus contactos.
                                            </p>

                                            <div>

                                                <form>


                                                    <div class="columns" v-if="professional">
                                                      <div class="column">
                                                          <input :class="{'badinput': errors.has('name')}" class="formfield" type="text" name="name" data-vv-as="nome" v-model="name" v-validate="'required|min:3'" placeholder="Designação comercial ou nome*">
                                                      </div>
                                                    </div>
                                                    <div class="columns" v-if="!professional">
                                                        <div class="column">
                                                            <input :class="{'badinput': errors.has('name')}" class="formfield" type="text" name="name" data-vv-as="nome" v-model="name" v-validate="'required|min:3'" placeholder="Nome completo*">
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column is-three-fifths">
                                                            <input :class="{'badinput': errors.has('email')}" class="formfield" type="text" name="email" data-vv-as="e-mail" v-model="email" v-validate="'required|email|uniqueemail'" placeholder="E-mail*">
                                                        </div>
                                                        <div class="column is-two-fifths" style="position: relative;">
                                                            <span>
                                                                <img src="/static/images/signup/pt.svg" style="width: 1rem;position: absolute;top: 1.1rem;left: 0.9rem;"/>
                                                            </span>
                                                            <input style="padding-left:2rem;" :class="{'badinput': errors.has('phone')}" class="formfield" type="text" name="phone" data-vv-as="telemóvel" v-model="phone" v-validate="'required|min:11|uniquephone'" placeholder="Telemóvel*" v-mask="'### ### ###'">
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column">
                                                            <div :class="{'badinput': errors.has('password')}" style="border:solid 1px white" class="field has-addons">
                                                                <input style="border:none" class="formfield" :type="hide ? 'password' : 'text'" name="password" data-vv-as="password" v-model="password" v-validate="'required|min:8'" placeholder="Defina a sua password">
                                                                <div class="control is-expanded">
                                                                    <a class="button" style="border:none;height:100%" @click="hide = !hide">
                                                                        <transition name="fade">
                                                                            <i v-if="hide" class="fa fa-eye" ></i>
                                                                            <i v-if="!hide" class="fa fa-eye-slash" ></i>
                                                                        </transition>

                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div class="columns" style="padding:0 0.7rem;">
                                                                <div class="column is-narrow">
                                                                    <p style="font-size: 0.7rem;"><em>Força da senha: </em></p>

                                                                </div>
                                                                <div class="column">
                                                                    <progress class="progress is-small"  :class="{
                                                    'is-danger': passScore <= 40,
                                                    'is-warning': passScore > 40 && passScore <= 65,
                                                    'is-success': passScore > 65
                                                    }":value="passScore" max="100"></progress>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="columns">
                                                        <div class="column">
                                                            <div :class="{'badinput': errors.has('passwd_c')}" style="border:solid 1px white" class="field has-addons">
                                                                <div class="control is-expanded">
                                                                    <input style="border:none" class="formfield" :type="hide ? 'password' : 'text'" name="passwd_c" data-vv-as="confirmação de password" v-model="passwd_c" v-validate="'required|confirmed:password'" placeholder="Confirme a sua password">
                                                                </div>

                                                                <div class="control">
                                                                    <a class="button" style="border:none;height:100%" @click="hide = !hide">
                                                                        <transition name="fade">
                                                                            <i v-if="hide" class="fa fa-eye" ></i>
                                                                            <i v-if="!hide" class="fa fa-eye-slash" ></i>
                                                                        </transition>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div class="columns">
                                                        <div class="column" style="text-align: left;">
                                                            <p :class="{'has-text-primary': accepterror}" style="font-size: 0.85rem; cursor:pointer;" @click="toggleItem(1, check)" >
                                                                <span>
                                                                    <transition name="fade" mode="out-in" >
                                                                        <i v-if="isItemActive(1,check)" class="fa fa-fw fa-check-square" style="color:#e90054;" ></i>
                                                                        <i v-else class="fa fa-fw fa-square-o" style="color:#e90054;" ></i>
                                                                    </transition>
                                                                </span>

                                                                Declaro que li e aceito os <a href="https://www.facilimo.pt/termos" target="_blank" style="color:#e90054;cursor:pointer;text-decoration:underline;">Termos e Condições</a> e a <a href="https://www.facilimo.pt/privacidade" target="_blank" style="color:#e90054;cursor:pointer;text-decoration:underline;">Política de Privacidade</a> do <b>FACILIMO.PT</b>

                                                            </p>

                                                            <p style="font-size: 0.85rem; cursor:pointer;" @click="toggleItem(2, check)">
                                                                <span>
                                                                    <transition name="fade" mode="out-in" >
                                                                        <i v-if="isItemActive(2,check)" class="fa fa-fw fa-check-square" style="color:#e90054;"></i>
                                                                        <i v-else class="fa fa-fw fa-square-o" style="color:#e90054;"  ></i>
                                                                    </transition>
                                                                </span>

                                                                Permitir mensagens de texto

                                                            </p>
                                                            <p style="line-height:1; font-size: 0.5rem; margin-left: 1.4rem;">Ao clicar nesta caixa, está a autorizar eletronicamento ao Facilimo a enviar-lhe mensagens de texto para notificá-lo de pedidos e atividade dos clientes.</p>


                                                        </div>
                                                    </div>

                                                    <div style="text-align:left;color:rgb(132, 138, 150); min-height:3rem;">
                                                        <div style="min-heigth:2.5rem;">
                                                            <div v-if="errors.collect('email').length > 0">
                                                                <p v-if="errors.collect('email')[0] == 'O e-mail encontra-se já registado.'" class="has-text-primary" style="font-size: 0.7rem;"><em>{{ errors.collect('email')[0] }}</em></p>
                                                            </div>
                                                            <div v-if="errors.collect('phone').length > 0">
                                                                <p v-if="errors.collect('phone')[0] == 'O telemóvel encontra-se já registado.'" class="has-text-primary" style="font-size: 0.7rem;"><em>{{ errors.collect('phone')[0] }}</em></p>
                                                            </div>

                                                            <!--
                                                                                                                    <a href="" class="button" @click="test">test</a>
                                                            -->
                                                        </div>
                                                    </div>
                                              </form>
                                            </div>
                                        </div>
                                    </transition>

                                </div>

                                <div v-if="signupFlow <= 6" class="procceed" style="margin: 0 0 0 -1rem;">

                                    <div class="" style="
                                        position: relative;
                                        display: flex;
                                        justify-content: center">
                                        <a v-if="signupFlow > 1 && signupFlow < 6" class="button has-text-primary" @click="signupFlow == 5 ? signupFlow = 3 : signupFlow--; lv2 = []; lv3 = [];"
                                           style="
                                           border: solid 1px #e90054;
                                           margin:0;
                                           background-color: transparent;">
                                            VOLTAR
                                        </a>
                                        <a v-if="!sending" class="button is-primary" :class="{'procceed-6': signupFlow == 6}" @click="nextStep" style="margin:0;">
                                            {{signupFlow < 6 ? "SEGUINTE" : "REGISTE-SE GRATUITAMENTE"}}
                                        </a>
	                                    <a v-else="" class="button is-primary" :class="{'procceed-6': signupFlow == 6}" style="margin:0;">
		                                    <i class="fa fa-spin fa-spinner"></i>
	                                    </a>
                                    </div>

                                    <p class="loginprompt">Já tem uma conta? <router-link to="login" id="loginprompt">Inicie sessão aqui</router-link></p>
                                </div>

                            </div>

                        </div>
                </div>

            </div>

        </section>

        <transition name="fade">
            <div class="modal" :class="{'is-active': loading}">
                <div class="modal-background" style="background-color: rgba(10, 10, 10, 0.50);">

                    <i class="fa fa-spinner fa-pulse fa-3x" style="position: absolute;top: 50%;left: 50%;"></i>

                </div>

            </div>
        </transition>

    </div>

</template>

<script>
import { mask } from "vue-the-mask";
import { removeChatMixin } from "../plugins/removeChatMixin";
import { notificationMixin } from "../plugins/notificationMixin";
import { Validator } from "vee-validate";
import { ErrorBag } from "vee-validate";
import { apiUrl } from "../vars";
import auth from "../auth";

export default {
  mixins: [notificationMixin],

  directives: { mask },

  data() {
    return {
      signupFlow: 1,
      loading: false,
        sending: false,

      //STEP 1
      name: null,
      email: null,
      phone: null,
      password: null,
      passwd_c: null,
      distance: 10,
      address: null,
      city: null,
      zip_home: null,
      zip_work: null,
      professional: 1,

      p1: null,
      p2: null,

      //STEP 2
      lv1: 0,
      lv1error: false,
      lv1opt: [
        "Selecione uma categoria",
        "Imóveis",
        "Casa",
        "Certificação",
        "Climatização",
        "Outros",
        "Aulas"
      ],
      ddfk_open: false,
      ddfakeopen: false,
      step2info: 0,
      step2text: [
        "",
        "Os clientes dizem-nos o que precisam de um Profissional e com base nas categorias escolhidas por si, receberá todos os pedidos dessas categorias.",
        "O registo é gratuito e assim que estiver validado poderá aceder a todos os pedidos de novos clientes. Apenas terá que pagar os pedidos que lhe interessa responder, usando para isso créditos. Oferecemos 15 créditos iniciais.",
        "Os pedidos vêm do preenchimento de um questionário pelo utilizador, sendo colocados na área de trabalho do Profissional dessa categoria. Responde apenas aos pedidos que lhe interessam."
      ],

      //STEP 3
      subgroups: [],
      lv2: [],
      lv2error: false,

      //STEP 4
      lv3: [],
      groups: [[], [], [], [], [], []],
      lv3error: false,

      //STEP 5
	    zip_response: {
		    message: ' ',
		    class: '',
		    error: true,
	    },
      ziperror: false,
      ddfk_dist_open: false,
      distopt: [2, 5, 10, 20, 25, 30, 50, 100, 150, 250, 500],
      center: { lat: 38.7274866, lng: -9.1421153 },

      //STEP 6
      hide: true,
      check: [],
      accepterror: false,

      bag: new ErrorBag()
    };
  },

  computed: {
    radius() {
      return this.distance * 1000;
    },
    zoom() {
      switch (true) {
        case this.radius < 2001:
          return 12;
        case this.radius < 5001:
          return 11;
        case this.radius < 10001:
          return 10;
        case this.radius < 25001:
          return 9;
        case this.radius < 50001:
          return 8;
        case this.radius < 100001:
          return 7;
        case this.radius < 150001:
          return 6;
        case this.radius < 250001:
          return 5;
        case this.radius < 500001:
          return 4;
        default:
          return 3;
      }
    },
    passScore() {
      if (this.password) {
        if (this.password.length < 8) {
          return 5 + 5 * this.password.length;
        } else {
          let types = 0;
          if (this.password.match("([a-z])+")) {
            types += 1;
          }
          if (this.password.match("([A-Z])+")) {
            types += 2;
          }
          if (this.password.match("([0-9])+")) {
            types += 3;
          }
          if (this.password.match("([^A-Za-z0-9])+")) {
            types += 4;
          }
          return Math.min(5.5 * this.password.length, 60) + 4 * types;
        }
      } else {
        return 5;
      }
    }
  },

  methods: {
    initialize() {
    	let lv1 = [];
    	axios.get(apiUrl + "/api/maingroup/all").then(r => {
    		lv1 = r.data;
    		this.lv1opt=lv1.map(l=>l.title);
    		this.lv1opt.unshift("Selecione uma categoria");
    		lv1.forEach((l,i)=>{
			    axios.get(`${apiUrl}/api/service/maingroup/${l.id}`).then(r => {
				    this.groups[i] = r.data;
			    });
		    })
		    axios.get(apiUrl + "/api/site/subgroups").then(r => {
			    this.subgroups = r.data;
		    });
	    })
    },

    test() {
      this.errors.forEach(console.log(value, key));
    },

    toggleItem(id, ary) {
      let i = ary.indexOf(id);
      if (i !== -1) {
        ary.splice(i, 1);
      }
      if (i === -1) {
        ary.push(id);
      }
    },

    isItemActive(id, ary) {
      return ary.indexOf(id) !== -1;
    },

	  treatZip(){
		  this.checkZip();
		  this.geoCode();
	  },

    geoCode() {
      let that = this;
      axios
        .get(apiUrl + "/api/geocode?address=" + this.zip_work)
        .then(response => {
          if (response.data.results.length) {
            that.center = response.data.results[0].geometry.location;
          }
        });
    },

	  checkZip() {
		  axios
			  .get(apiUrl + "/api/zip/check/" + this.zip_work)
			  .then(response => {
				  if (response.data.match) {
					  this.ziperror = false;
					  this.zip_response.error = false;
					  this.zip_response.message = "O código postal é válido";
					  this.zip_response.class = "has-text-success";
				  } else if (response.data.suggestions) {
					  this.zip_response.error = true;
					  this.ziperror = true;
					  this.zip_response.message =
						  "Código postal não encontrado. Por favor introduza outro válido. (Sugestão: ";
					  response.data.suggestions.forEach(s => {
						  this.zip_response.message += ` ${s.num_cod_postal}-${s.ext_cod_postal},`;
					  });
					  this.zip_response.message = this.zip_response.message.slice(0,-1);
					  this.zip_response.message += ')';
					  this.zip_response.class = "has-text-primary";
				  } else {
					  this.zip_response.error = true;
					  this.ziperror = true;
					  this.zip_response.message = "Código postal não encontrado. Por favor introduza outro válido.";
					  this.zip_response.class = "has-text-primary";
				  }
				  this.loadmap = true;
			  });
	  },

    nextStep() {
      if (this.signupFlow === 1) {
        let that = this;
        this.$validator.validateAll().then(result => {
          if (result) {
            that.signupFlow = that.professional === 1 ? 2 : 5;
            that.zip_work = that.zip_home;
            that.treatZip();
            return;
          }
          that.error = "Por favor, preencha todos os campos.";
        });
        return;
      }

      if (this.signupFlow === 2) {
        if (this.lv1 > 0) {
          this.signupFlow = 3;

          this.lv1error = false;
        } else {
          this.lv1error = true;
        }
        return;
      }

      if (this.signupFlow === 3) {
        if (this.lv2.length > 0) {
          this.loading = true;

          if (this.lv1 === 1) {
            let lv3filtered = this.groups[0].filter(s => {
              return this.lv2.indexOf(s.sub_group_id) !== -1;
            });
            /*for (let i = 0; i < lv3filtered.length; i++) {
                        		this.lv3.push(lv3filtered[i].id)
	                        }*/
            lv3filtered.forEach(l => {
              this.lv3.push(l.id);
            });
            console.log("skip ahead");
            this.signupFlow = 5;
            this.loading = false;
            return;
          }

          this.lv2.forEach(l2 => {
            let services = [];
            this.groups[this.lv1 - 1].forEach(s => {
              if (s.sub_group_id === l2) {
                services.push(s);
                this.lv3.push(s.id);
              }
            });
            /* if (services.length === 1) {
                                this.lv3.push(services[0].id)
                            }*/
          });

          if (this.lv3.length === this.lv2.length) {
            this.loading = false;
            this.lv2error = false;
            console.log("skip ahead");
            this.signupFlow = 5;
            return;
          }

          console.log("no skip");
          this.loading = false;

          this.signupFlow = 4;
          this.lv2error = false;
        } else {
          this.lv2error = true;
        }
        return;
      }

      if (this.signupFlow === 4) {
        if (this.lv3.length > 0) {
          this.signupFlow = 5;
          this.lv3error = false;
        } else {
          this.lv3error = true;
        }
        return;
      }

      if (this.signupFlow === 5) {
        if (this.zip_work.length !== 8) {
          this.ziperror = true;
          return;
        }
        this.signupFlow = 6;
        return;
      }

      if (this.signupFlow === 6) {
        let that = this;
        this.loading = true;

        this.accepterror = this.check.indexOf(1) !== -1 ? false : true;

        if (this.accepterror) {
          this.loading = false;

          return;
        }

        this.$validator.validateAll().then(result => {
          if (result) {
            let o = {
              name: this.name,
              email: this.email.toLowerCase(),
              phone: "+351 " + this.phone,
              password: this.password,
              distance: this.distance,
              address: this.address,
              city: this.city,
              zip_home: this.zip_home,
              zip_work: this.zip_work,
              professional: this.professional,
              p1: this.p1,
              p2: this.p2,
              lv3: this.lv3,
                lat: this.center.lat,
                lng: this.center.lng,
            };

            let that = this;

            let p = {
              email: o.email,
              password: o.password
            };

            this.sending = true;

            axios
              .post(apiUrl + "/api/user/create", o)
              .then(() => {
                auth.signin(that, p);
	              //this.sending = false;
              })
              .catch(err => {
	              this.sending = false;
                that.error = "Erro ao gravar o registo. " + err.statusText;
                this.loading = false;
              });
          }
          that.error = "Por favor, preencha todos os campos.";
          this.loading = false;
        });
        this.loading = false;
      }
    }
  },

  watch: {
    signupFlow: function() {
      if (this.signupFlow === 2) {
        this.zip_work = this.zip_home;
        this.geoCode();
      }
    }
  },

  created() {
    this.initialize();

    Validator.extend("uniqueemail", {
      getMessage: field => `O e-mail encontra-se já registado.`,
      validate: value =>
        new Promise(resolve => {
          // API call or database access.
          axios
            .post(apiUrl + "/api/validate/email", { email: value })
            .then(response => {
              // Notice that we return an object containing both a valid property and a data property.
              resolve({
                valid: response.data.valid,
                data: {
                  message: response.data.message
                }
              });
            });
        })
    });

    Validator.extend("uniquephone", {
      getMessage: field => `O telemóvel encontra-se já registado.`,
      validate: value =>
        new Promise(resolve => {
          // API call or database access.
          axios
            .post(apiUrl + "/api/validate/phone", { phone: "+351 " + value })
            .then(response => {
              // Notice that we return an object containing both a valid property and a data property.
              resolve({
                valid: response.data.valid,
                data: {
                  message: response.data.message
                }
              });
            });
        })
    });

    this.name = this.$route.params.name || null;
    this.email = this.$route.params.email || null;
    this.p1 = this.$route.params.p1 || null;
    this.p2 = this.$route.params.p2 || null;
  }
};
</script>

<style scoped lang="scss">
#signup {
  position: relative;
}

#signup .columns {
  position: relative;
}

#signup .fullcol {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  padding: 0;
}

.loginbg {
  background-image: url("/static/images/signup/LoginImage.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.loginbg-txt {
  text-align: center;
  font-size: 1.35rem;
  color: white;
  font-weight: 600;
  line-height: 1.2;
}

.loginbgsocial {
  text-align: center;
  padding: 4rem 0 2rem;
}

.loginbgsocial p {
  text-align: center;
  color: #e90054;
  font-size: 0.9rem;

  font-weight: 600;
}

.loginbgsocial i {
  text-align: center;
  font-size: 1.15rem;
  color: white;
  padding: 0.3rem;
  font-weight: 500;
}

.loginaction {
  background-color: #f1f1f1;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.loginlogo {
  padding: 4.5rem 0 0;
}

#registese {
  color: #2d3256;
  font-weight: 600;
  text-align: left;
  padding: 1rem 0;
  font-size: 1.2rem;
  margin-left: -0.5rem;
}

.step1container {
  padding: 1rem 0;
}

.loginprompt {
  margin-top: 1rem;
  color: #848a96;
  font-size: 0.9rem;
}

#loginprompt {
  color: #e90054;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.9rem;
}

form .column {
  padding: 0.3rem;
}

.loginlogo img {
  height: 3rem;
}

.formfield {
  //border: solid 1px #848a96;
  background-color: white;
  padding: 0.5rem;
  width: 100%;
  font-size: 0.9rem;
}

.form-help {
  margin-top: 0.2rem;
  font-size: 0.6rem;
  font-style: italic;
  font-weight: 300;
  text-align: left;
}

.procceed {
  text-align: center;
  padding: 0 0 4.5rem;
}

.procceed .button {
  padding: 1.25rem 3rem;
  font-weight: 600;
  font-size: 0.9rem;
  margin: 1rem;
}

.toggleblock .button {
  padding: 1.25rem;
  font-weight: 600;
  border: solid 1px #848a96;
  background-color: #f1f1f1;
  color: #848a96;
  font-size: 0.9rem;
}

.toggleblock .button i {
  font-size: 0.75rem;
  font-weight: 300;
}

.toggleblock .active {
  padding: 1.25rem;
  font-weight: 600;
  background-color: #e90054;
  color: white;
  border: solid 1px #e90054;
}

.formcontainer {
  margin: auto;
  max-width: 30rem;
  min-width: 30rem;
}

input {
  border: solid 1px #f1f1f1;
}

.badinput {
  border: solid 1px #e90054 !important;
}

.stepcontent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
}

.flowcontrol {
  display: flex;
  flex-direction: row;
  align-items: left;
}

#step2title {
  color: #2d3256;
  font-weight: 700;
  text-align: left;
  padding: 0 0 1rem;
  font-size: 1.5rem;
  text-transform: uppercase;
  //margin-left: -0.5rem;
}

#flow-step-6 {
  padding: 0 0 1rem;
}

.procceed-6 {
  max-width: 29rem;
  min-width: 29rem;
}

#step2text {
  color: #2d3256;
  font-weight: 400;
  text-align: left;
  //padding: 2rem 0 1rem;
  font-size: 1rem;
  //text-transform: uppercase;
  //margin-left: -0.5rem;
}

#step2sub {
  color: #2d3256;
  font-weight: 500;
  text-align: left;
  padding: 2rem 0 1rem;
  font-size: 1rem;
  //text-transform: uppercase;
  //margin-left: -0.5rem;
}

.step2open {
  line-height: 1;
  position: relative;
  text-align: justify;
  font-size: 0.8rem;
  color: #ffffff;
  background-color: rgba(45, 50, 86, 0.75);
  padding: 0.75rem;
  min-height: 7.5rem;
  border-radius: 3px;
}

.fakeddcontainer {
  width: 100%;
  position: relative;
  margin: 0 0 0.5rem;
}

.fakedd {
  position: relative;
  background-color: white;
  line-height: 1.7rem;
  padding: 0 0.5rem;
  font-size: 0.9rem;
  min-height: 2rem;
  min-width: 12rem;
  color: #4a4a4a;
  border: solid 2px white;
  text-align: left;
}

.ddfake-open {
  background-color: white;
  position: absolute;
  z-index: 2;
  width: 100%;
  border: solid 1px #969696;
}

.ddfake-opt {
  text-align: left;
  font-size: 0.9rem;
  color: black;
  line-height: 2rem;
  z-index: 3;
  cursor: pointer;
  padding: 0 0.5rem;
}

.ddfake-opt:hover {
  color: white;
  background-color: #e90054;
}

.f-button {
  font-size: 0.8rem;
  padding: 1rem 0.25rem 1rem 0.5rem;
  margin-bottom: 0.5rem;
}

.f-signup-btn {
  justify-content: space-between !important;
}

.stepinfo {
  background-color: #e90054 !important;
}

#flow-step-3 {
  align-items: center;
}

#flow-step-4 {
  align-items: center;
}

#flow-step-5 {
  align-items: center;
}

.steptitle {
  color: #2d3256;
  font-weight: 700;
  text-align: center;
  padding: 2rem 0 0;
  font-size: 1.5rem;
  //margin-left: -0.5rem;
}

.steptext {
  color: #2d3256;
  font-weight: 400;
  text-align: center;
  margin: 0 0 2rem;
  font-size: 1rem;
  //text-transform: uppercase;
  //margin-left: -0.5rem;
}

.step-list {
  width: 100%;
  max-height: 18rem;
  min-height: 18rem;
  margin-bottom: 1rem;
  overflow-y: auto;
  text-align: left;
  background-color: white;
  padding: 0.5rem 0.3rem;
  max-width: 30rem;
  min-width: 30rem;
}

.step-list-item {
  padding: 0.3rem 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
}

#map {
  display: flex;
  //height:400px;
  justify-content: center;
}

.signup-map-container {
  width: 93%;
  height: 200px;
}

.f-signup-geo p {
  //padding: 2rem 0 1rem 0;
  margin-top: 0.1rem;
  color: #2d3256;
  font-size: 0.9rem;
  font-weight: 400;
  //line-height: 1.2;
}

.f-signup-geo .column {
  padding: 1rem;
}

.f-signup-geo input {
  margin: 0.25rem;
  //border: solid 2px #e90054;
  border-radius: 0;
  font-size: 0.9rem;
  max-width: 90%;
}

@media screen and (max-height: 570px) and (min-width: 769px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 720px) {
  .procceed {
    text-align: center;
    padding: 0 0 3rem;
  }

  .loginlogo {
    padding: 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Signup.vue